import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import TableService from '@/modules/tables/TableService';
var table = {
  name: '',
  qr: '',
  zone_id: '',
  style: ''
};

var TableModel =
/** @class */
function (_super) {
  __extends(TableModel, _super);

  function TableModel() {
    var _this = _super.call(this, table, TableService) || this;

    _this.modelName = 'Mesa';
    _this.request = 'JSON';
    return _this;
  }

  TableModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var createValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.create.call(this, data, toast, toastConfig)];

          case 1:
            createValue = _a.sent();
            return [2
            /*return*/
            , createValue];
        }
      });
    });
  };

  TableModel.prototype.update = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var updateValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.update.call(this, data, toast, toastConfig)];

          case 1:
            updateValue = _a.sent(); // await this.restoreTablesOrder();

            return [2
            /*return*/
            , updateValue];
        }
      });
    });
  }; // tslint:disable-next-line:max-line-length


  TableModel.prototype.delete = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, Promise, function () {
      var deleteValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.delete.call(this, data, toast, toastConfig)];

          case 1:
            deleteValue = _a.sent();
            return [2
            /*return*/
            , deleteValue];
        }
      });
    });
  };

  TableModel.prototype.getTableStyles = function (data) {
    var _a;

    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getTableStyles({
              query: data
            })];

          case 1:
            response = _b.sent();
            return [2
            /*return*/
            , (_a = response.data.table_style) !== null && _a !== void 0 ? _a : []];
        }
      });
    });
  };

  TableModel.prototype.createTableStyles = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.createTableStyles({
              query: {
                table_style: data
              }
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , response.complete];
        }
      });
    });
  };

  TableModel.prototype.deleteAllStyles = function () {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.deleteAllStyles({})];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , response.complete];
        }
      });
    });
  };

  TableModel.prototype.updateTableStyles = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.updateTableStyles({
              query: data
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , response.complete];
        }
      });
    });
  };

  TableModel.prototype.deleteTableStyles = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.deleteTableStyles(data)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , response.complete];
        }
      });
    });
  };

  TableModel.prototype.getTablesListByLocal = function (protocol) {
    return __awaiter(this, void 0, Promise, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getTablesListByLocal(__assign({
              method: 'GET'
            }, protocol))];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0
            }];
        }
      });
    });
  };

  return TableModel;
}(BaseModel);

export default TableModel;